export const Logo = ({ light = false, className = "h-11 sm:h-12" }) => (
  <img
    src={light ? "/brand/plumberoo-logo-light.png" : "/brand/plumberoo-logo.png"}
    alt="Plumberoo Plumbing & Gas Pty Ltd"
    className={`w-auto select-none ${className}`}
    draggable="false"
    data-testid="brand-logo"
  />
);
